if (!AFRAME.components['envmap']) {
	AFRAME.registerComponent('envmap', {
		schema: {
			src: {
				type: 'string',
				default: '',
				required: true
			},
			format: {
				type: 'string',
				default: '.jpg',
				required: false
			},
			intensity: {
				type: 'number',
				default: 1,
				required: false
			}
		},
		envMap: null,
		init: function() {
			this.modelloaded = AFRAME.utils.bind(this.modelloaded, this);
			this.el.addEventListener('model-loaded', this.modelloaded);
			this.envMap = new THREE.CubeTextureLoader().load([
				this.data.src + '/posx' + this.data.format,
				this.data.src + '/negx' + this.data.format,
				this.data.src + '/posy' + this.data.format,
				this.data.src + '/negy' + this.data.format,
				this.data.src + '/posz' + this.data.format,
				this.data.src + '/negz' + this.data.format
			]);
		},
		update: function() {},
		traverseForMeshes: function(object) {
			var meshes = [];
			if (object.children) {
				if (object.children.length > 0) {
					for (var i = 0; i < object.children.length; i++) {
						meshes = meshes.concat(this.traverseForMeshes(object.children[i]));
					}
				}
			}
			if (object.geometry) {
				meshes.push(object);
			}
			return meshes;
		},
		modelloaded: function() {
			var meshes = this.traverseForMeshes(this.el.object3D);
			for (var i = 0; i < meshes.length; i++) {
				meshes[i].material.envMap = this.envMap;
				meshes[i].material.envMapIntensity = this.data.intensity;
			}
		}
	});
}
